import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
} from '@material-ui/core';
import Page from 'src/components/Page';
import ProductCard from '../ProductListView/ProductCard';
import ImageApi from '../../../utils/apiManager/constrollers/imageApi';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    padding: '0',
  },
  cardsbox: {
    marginTop: '25px',
  },
  productCard: {
    width: '100%',
    height: '100%',
  },
  cardItem: {
    width: '280px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: '0 20px 0 20px',
    },
  },
}));

const AllImagesView = () => {
  const classes = useStyles();
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      const imageApi = await ImageApi.getInstance();
      const data = await imageApi.fetchUserImages();
      setImages(data || []);
    };
    fetchImages();
  }, []);

  return (
    <Page
      className={classes.root}
      title="All Images"
    >
      <Container maxWidth={false}>
        <Box mt={12} className={classes.cardsbox}>
          <Grid
            container
            spacing={3}
            flex-wrap="wrap"
            justify-content="space-evenly"
          >
            {images.map((product, index) => (
              <Grid
                item
                key={product.id || product.fileId}
                className={classes.cardItem}
              >
                <ProductCard
                  index={index}
                  className={classes.productCard}
                  product={product}
                  onDelete={(id) => setImages((prev) => prev.filter((img) => img.id !== id))}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Page>
  );
};

export default AllImagesView;
